import { Text } from "@clipboard-health/ui-components";
import { Box, Stack, useTheme } from "@mui/material";
import { ScoreCounter } from "@src/appV2/redesign/EmergencyCredits/components/ScoreCounter";
import type { ReactNode } from "react";

const SCORE_ANIMATION_DURATION_MS = 1500;

interface CancellationScoreDisplayProps {
  score: number;
  animated?: boolean;
  startScore?: number;
  isRestricted?: boolean;
  isBecomingRestricted?: boolean;
  children?: ReactNode;
}

export function CancellationScoreDisplay(props: CancellationScoreDisplayProps): JSX.Element {
  const {
    score,
    animated = false,
    startScore,
    isRestricted = false,
    isBecomingRestricted = false,
    children,
  } = props;
  const theme = useTheme();

  const showScore = !isRestricted || isBecomingRestricted;

  return (
    <Stack alignItems="center" textAlign="center" spacing={6}>
      <Stack spacing={0} alignItems="center">
        <Text
          variant="h3"
          textAlign="center"
          sx={{
            color: (t) => (isRestricted ? t.palette.error.main : t.palette.intent?.error.text),
          }}
        >
          Shift cancelled
        </Text>
        {isBecomingRestricted ? (
          <Text
            variant="h3"
            textAlign="center"
            sx={{
              color: (t) => t.palette.error.main,
            }}
          >
            Your account is Restricted
          </Text>
        ) : null}
      </Stack>
      {showScore && (
        <Stack sx={{ marginTop: "24px !important" }} alignItems="center">
          <Text
            variant="body2"
            sx={(t) => ({
              color: t.palette.text.secondary,
            })}
          >
            Your new Clipboard Score
          </Text>
          <Box sx={{ marginTop: 8 }}>
            <ScoreCounter
              startValue={startScore ?? score}
              endValue={score}
              animationEnabled={animated}
              color={theme.palette.text.primary}
              duration={SCORE_ANIMATION_DURATION_MS}
            />
          </Box>
        </Stack>
      )}
      {children}
    </Stack>
  );
}
